import Styled from '@/components/banners/VideoBanner/components';
import Image from '@/components/Image';
import Modal from '@/components/modals/Modal';
import YouTubeVideo from '@/components/YouTubeVideo';
import gtm from '@/lib/gtm';
import { maybeNotSet } from '@/lib/typescript-helpers';
import { COLORS } from '@/styles/color';
import { FC, useState } from 'react';

interface VideoBannerProps {
  heading: string;
  buttonText?: string;
  youtubeVideoId: string;
  coverImage: {
    src: string;
    width: number;
    height: number;
  };
}

const VideoBanner: FC<VideoBannerProps> = ({ heading, buttonText = 'Watch video', youtubeVideoId, coverImage }) => {
  const [showVideo, setShowVideo] = useState<boolean>(false);

  return (
    <Styled.Section>
      <Styled.StyledContainer>
        <Styled.ContentWrapper>
          <Styled.Heading>{heading}</Styled.Heading>

          <Styled.WatchVideoButton
            onClick={() => {
              gtm.track('click', {
                element_type: 'button',
                location: `Video Banner - ${maybeNotSet(heading)}`,
                element_label: maybeNotSet(buttonText),
              });

              setShowVideo(true);
            }}
          >
            <span>{buttonText}</span>

            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="16" fill={COLORS.BLACK} />
              <path d="M21.747 16L12.8008 21.3333L12.8008 10.6666L21.747 16Z" fill={COLORS.WHITE} />
            </svg>
          </Styled.WatchVideoButton>
        </Styled.ContentWrapper>

        <Styled.ImageWrapper onClick={() => setShowVideo(true)}>
          <Styled.PlayButton />
          <Image src={coverImage.src} width={coverImage.width} height={coverImage.height} alt="" />
        </Styled.ImageWrapper>
      </Styled.StyledContainer>

      {showVideo && (
        <Modal name={`${heading} - Video`} onClose={() => setShowVideo(false)}>
          <YouTubeVideo videoId={youtubeVideoId} coverSrc={coverImage.src} showPlayButton={false} autoplay />
        </Modal>
      )}
    </Styled.Section>
  );
};

export default VideoBanner;
